//======> Docementation <======//
registerBlockType("tornado/singlesrv", {
  title: __("Inner Single Service", "tornado"),
  description: __("lll", "tornado"),
  icon: "feedback",
  category: "tornado",
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    featImgAbout: {
      type: "string",
      default: "عنوان 1",
    },
    head: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    head2: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    body: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },
    body2: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },
    body3: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },
    body4: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },

    qoute: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق",
    },
    authorName: {
      type: "string",
      default: "المصدر : عبدالله رمضان",
    },
    feats: {
      type: "string",
      default: "3000*1.5*100*150",
    },
  },
  edit({ attributes, setAttributes, className }) {
    const {
      featImgAbout,
      head,
      head2,
      body2,
      body,
      body3,
      body4,
      authorName,
      qoute,
      feats,
    } = attributes;
    function onChangehead(newhead) {
      setAttributes({ head: newhead });
    }
    function onChangehead2(newhead2) {
      setAttributes({ head2: newhead2 });
    }
    function onChangebody(newBody) {
      setAttributes({ body: newBody });
    }
    function onChangebody2(newBody2) {
      setAttributes({ body2: newBody2 });
    }
    function onChangebody3(newBody3) {
      setAttributes({ body3: newBody3 });
    }
    function onChangebody4(newBody4) {
      setAttributes({ body4: newBody4 });
    }
    function onChangeQoute(newQoute) {
      setAttributes({ qoute: newQoute });
    }
    function onchangeAuthor(newAuthor) {
      setAttributes({ authorName: newAuthor });
    }
    function onChangeFeat(newfeat) {
      setAttributes({ feats: newfeat });
    }

    function onChangefeatImg(newIMG) {
      setAttributes({ featImgAbout: newIMG.sizes.full.url });
    }

    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p>Select The Image !</p>
            <MediaUpload
              onSelect={onChangefeatImg}
              value={featImgAbout}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />
          </PanelBody>
        </InspectorControls>
        <div class="primary-block mb30">
        <div class="rich-content">
          <div class="row align-center-y">
            <div class="col-12 col-l-6">
              <img
                  src={featImgAbout}
                  alt=""
                  class="block-lvl mb30 mt30 round-corner"
                />
            </div>
            <div class="col-12 col-l-6">
               <RichText
                  tagName="h2"
                  className="secondary-color"
                  value={head}
                  onChange={onChangehead}
                />
                <RichText
                  tagName="p"
                  className="secondary-color"
                  value={body}
                  onChange={onChangebody}
                />
               <div class="half-space squared">
                  <RichText
                    tagName="ul"
                    multiline="li"
                    key="editable"
                    value={feats}
                    onChange={onChangeFeat}
                    keepPlaceholderOnFocus={true}
                  />
                </div>
                <RichText
                  key="editable"
                  tagName="p"
                  className="secondary-color"
                  value={body2}
                  onChange={onChangebody2}
                />
            </div>
          </div>
          <hr class="mb30" />
           <RichText tagName="h3" value={head2} onChange={onChangehead2} />
              <RichText tagName="p" value={body3} onChange={onChangebody3} />
          <blockquote>
             <RichText tagName="p" value={qoute} onChange={onChangeQoute} />
                <RichText
                  tagName="span"
                  className="quote-name"
                  value={authorName}
                  onChange={onchangeAuthor}
                />
          </blockquote>

      <RichText tagName="p" value={body4} onChange={onChangebody4} />
        </div>
      </div>
      </Panel>
    );
  },
  save({ attributes, className }) {
    const {
      featImgAbout,
      head,
      head2,
      body2,
      body,
      body3,
      body4,
      authorName,
      qoute,
      feats,
    } = attributes;

    return (
      <div class="primary-block mb30">
        <div class="rich-content">
          <div class="row align-center-y">
            <div class="col-12 col-l-6">
              <img
                src={featImgAbout}
                alt=""
                class="block-lvl mb30 mt30 round-corner"
              />
            </div>
            <div class="col-12 col-l-6">
              <RichText.Content tagName="h2" value={head} />
              <RichText.Content tagName="p" value={body} />
              <RichText.Content
                tagName="ul"
                className="half-space squared"
                multiline="li"
                value={feats}
              />
              <RichText.Content tagName="p" value={body2} />
            </div>
          </div>
          <hr class="mb30" />
          <RichText.Content tagName="h3" value={head2} />

          <RichText.Content tagName="p" value={body3} />
          <blockquote>
            <RichText.Content tagName="p" value={qoute} />
            <RichText.Content
              className="quote-name"
              tagName="span"
              value={authorName}
            />
          </blockquote>

          <RichText.Content tagName="p" value={body4} />
        </div>
      </div>
    );
  },
});
